import React,{useEffect, useState} from 'react';
import {RouteComponentProps} from 'react-router-dom';
import useReactRouter from 'use-react-router';
import GuideIndex from './GuideIndex';
import GuideDetail from './GuideDetail';
import Loading from './Loading';
import {HelpDict} from './GuideDict';
import Ajax from './Ajax';

interface GuideProps {
    
}

interface HelpIndexProps extends RouteComponentProps<{helpGroup:string,helpId:string}> {
	
}

const Help:React.FC<GuideProps> = (props)=> {
	const [loading,setLoading] = useState(true);
	const [helpDict,setHelpDict] = useState({} as HelpDict);

    const hip:HelpIndexProps = useReactRouter();
    const helpId = hip.match.params.helpId;
    const helpGroup = hip.match.params.helpGroup;

	let detail = false;

	if( helpDict[helpGroup] ){
		detail = true;
	}

	useEffect(()=>{
		Ajax.setEditorId(0);
		Ajax.send("guide/dict",{},(res:any)=>{
			setHelpDict(res.dict);
			setLoading(false);
		});
	},[])

	useEffect(()=>{
		window.scroll(0,0);
	},[helpId,helpGroup]);

	return (
		<>
		{loading ? (
			<Loading isLoading={true}/>
		):(
			<>
			{!detail ? (
			<GuideIndex dict={helpDict}/>
			):(
			<GuideDetail dict={helpDict} group={helpGroup} id={helpId}/>
			)}
			</>
		)
		}
		</>
	)
}

export default Help;